<body>
  <!--  Body Wrapper -->
  <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-navbarbg="skin6" data-sidebartype="full"
    data-sidebar-position="fixed" data-header-position="fixed">

    <div class="d-flex justify-content-end">
      <button (click)="close()" type="button" class="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="body-wrapper">
      <div class="container-fluid ">
        <div class="row">
          <div class="container my-4">

            <div class="align-items-center justify-content-between">

              <div class="card">

                <div class="card-body">
                  <h5 id="upper" class="" style="color: black;">Informations machine</h5>
                  <div class="container mt-4">

                    <form>
                      <div class="row g-3">
                        <div class="col-12 col-md-4">
                          <label for="nom" class="form-label">Nom de la machine</label>
                          <input [(ngModel)]="item.nom" name="nom" type="text" class="form-control" id="nom"
                            placeholder="Votre nom">
                        </div>
                        <div class="col-12 col-md-4">
                          <label for="numero_serie" class="form-label">No série</label>
                          <input [(ngModel)]="item.numero_serie" name="numero_serie" type="nubmer" class="form-control"
                            id="numero_serie" placeholder="Numéro de série de la machine">
                        </div>
                        <div class="col-12 col-md-4">
                          <label for="type" class="form-label">Type de machine</label>
                          <select [(ngModel)]="item.type_machine_id" name="type" class="form-select" id="type">
                            <option selected>Choisir le type de machine</option>
                            <option *ngFor="let item of typeMachinItems" [value]="item.id">{{ item.nom }}</option>
                          </select>
                        </div>

                        <!-- <div class="col-12 col-md-4">
                          <label for="assessoire" class="form-label">Accessoires compatibles</label>
                          <select name="assessoire" class="form-select" id="assessoire">
                            <option selected>Choisir l'assessoires</option>
                            <option> charrue pour tracteur </option>
                          </select>
                        </div> -->
                        <div class="col-md-4 mb-3">
                          <label class="form-label">Accessoires compatibles</label>
                          <div class="text-center">
                            <button (click)="showDialog('left')" class="btn btn-outline-info"> selectionnez</button>
                          </div>
                        </div>

                        <div class="col-12 col-md-4">
                          <label for="maintenance" class="form-label">Type de maintenance</label>
                          <textarea [(ngModel)]="item.type_maintenance" rows="1" name="type_maintenance_id"
                            class="form-control" type="text">
                            </textarea>
                        </div>

                        <div class="col-12 col-md-4">
                          <label for="etat" class="form-label">Etat machine</label>
                          <select [(ngModel)]="item.etats_machines_id" name="etats_machines_id" class="form-select"
                            id="etat">
                            <option selected>Choisir l'etat de la machine</option>
                            <option *ngFor="let item of etatItems" [value]="item.id">{{ item.nom }}</option>

                          </select>
                        </div>

                        <div class="col-12 col-md-4">
                          <label for="condition" class="form-label">Condition de location</label>
                          <textarea [(ngModel)]="item.condition_location" class="form-control" rows="1"
                            name="condition_location" id="condition_location"></textarea>
                        </div>

                        <div class="col-12 col-md-4">
                          <label for="montant" class="form-label">Montant location </label>
                          <input [(ngModel)]="item.montant" name="montant" type="number" class="form-control"
                            id="montant" placeholder="Numéro de série de la machine">
                        </div> <div class="col-12 col-md-4">
                          <label for="montant" class="form-label">Localisaion </label>
                          <input [(ngModel)]="item.localisation" name="localisation" type="text" class="form-control"
                            id="localisation" placeholder="Localisaion de la machine">
                        </div>

                        <div class="form-group  col-md-4">
                          <label for="name">Photo</label>

                          <input  (change)="onFileSelected($event)" name="photo" type="file" class="form-control"
                            id="name">

                        </div>

                        <div  *ngIf="item" class="mt-3 d-flex justify-content-center">
                          <img [src]="photoPreview" alt="Aperçu de la photo" style="width: 50%; height: 300px;">
                      </div>
                      </div>
                      <div class="d-flex justify-content-end mt-4">
                        <a  title="Cliquez ici pour annuler " href="javascript: void(0);" (click)="close()"
                        class="btn btn-secondary me-3"
                        style="color: white; border: none; font-weight: 800; font-size: 16px; height: 38px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                        Annuler &nbsp;
                      </a>

                        <a title="Cliquez ici pour enregistrer " href="javascript: void(0);"
                          (click)="editMachine()" class="btn"
                          style="color: white; background-color: #578D63; border: none; font-weight: 800; font-size: 16px; height: 38px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                          Enregistrer &nbsp;<i class="pi pi-save " style="font-size: 1rem"></i>

                        </a>
                      </div>

                    </form>

                  </div>


                </div>
              </div>
            </div>



          </div>

        </div>
      </div>
    </div>
  </div>

</body>
<p-dialog header="Accessoires compatibles" [modal]="true" [(visible)]="visible" [position]="position"
  [style]="{ width: '25rem' }">
  <div class="row">
    <div *ngFor="let item of accessoireItems" class="col-6 form-check">
      <input
        type="checkbox"
        [(ngModel)]="item.accessoire_checked"
        class="form-check-input"
        id="accessoire{{ item.id }}"
      />
      <label class="form-check-label" for="accessoire{{ item.id }}">
        {{ item.nom }}
      </label>
    </div>
  </div>
   <ng-template pTemplate="footer">
    <button type="button" pButton label="OK" class="p-button-sm p-button-primary" (click)="onOkClick()"></button>
  </ng-template>

</p-dialog>

<p-dialog header="Propriétaire de la machine" [modal]="true" [(visible)]="isvisibleProprietaire" [position]="position"
  [style]="{ width: '30rem' }">

  <!-- Informations propriétaire -->
  <div class="mb-3">
    <label>Nom</label>
    <input type="text" pInputText class="w-100" [(ngModel)]="proprietaire.nom" class="form-control">
  </div>

  <div class="mb-3">
    <label>Prénom</label>
    <input type="text" pInputText class="w-100" [(ngModel)]="proprietaire.prenom"  class="form-control">
  </div>

  <div class="mb-3">
    <label>Téléphone</label>
    <input type="text" pInputText class="w-100" [(ngModel)]="proprietaire.telephone"  class="form-control">
  </div>

  <div class="mb-3">
    <label>Email</label>
    <input type="email" pInputText class="w-100" [(ngModel)]="proprietaire.email" class="form-control">
  </div>

  <div class="mb-3">
    <label>Adresse</label>
    <textarea pInputTextarea  [(ngModel)]="proprietaire.adresse"  class="form-control w-100"></textarea>
  </div>

  <hr>


  <ng-template pTemplate="footer">
    <button (click)="closeProprietaireModal()" type="button" pButton label="OK" class="p-button-sm p-button-primary">
    </button>
  </ng-template>

</p-dialog>
<!-- <p-toast position="top-center" /> -->

<ngx-ui-loader></ngx-ui-loader>
